// import { withRouter } from "react-router-dom";
import classes from "./header.module.css";
import { withRouter } from '../../wrappers/with-routre';

const Header = ({ history }) => {
  console.warn('@@@ history ', history)
  const goHome = () => {
    history("/");
  };
  return (
    <header className={classes.header}>
      <h1 className={classes.title} onClick={goHome}>
        Расчёты
      </h1>
    </header>
  );
};

export default withRouter(Header);
// export default Header;
